//require( './signature' );
import { isMobile } from 'mobile-device-detect';
import modular from 'modujs';
import * as modules from './modules/_all';
import Emitter from "tiny-emitter/instance";


const app = new modular( { modules : modules } );

const html = document.documentElement;

window.onload = () => {
    html.classList.add('is-loaded');
    html.classList.add('is-ready');
    html.classList.remove('is-loading');
    html.classList.toggle( 'is-mobile', isMobile );
    app.init( app );
};


const logEvent = ( args ) => {
    if( typeof ga === 'function' ){
        ga( 'create', 'UA-250142343-1', 'auto' );
        ga('send', 'event', args );
    }
};

document.addEventListener( 'click', e => {
    if (typeof ga === 'function' && e.target.tagName === 'A' && ( e.target.href.includes( 'reserve-online.net' )  )) {
        e.preventDefault();
        logEvent({
            'eventCategory': 'Outbound',
            'eventAction': e.target.textContent,
            'eventLabel': e.target.href,
            'hitCallback': function() {
                window.location.href = e.target.href;
            }
        });
    }


});

document.addEventListener( 'click', e => {
    if( typeof bookClicked === 'function' ){
        if( e.target.tagName === 'A' && e.target.classList.contains( 'button' ) && e.target.href.startsWith( "https://cdn.triparound.com/widget/master/" ) ) {
            e.preventDefault();
            const a = e.target;
            var urlParams = new URLSearchParams( a.href.split( '?' )[ 1 ] );
            a.dataset.lang = urlParams.get( 'locale' );
            a.dataset.bid = urlParams.get( 'business_id' );
            a.dataset.pid = urlParams.get( 'product_id' );
            bookClicked( a );
        }
    }
});

document.addEventListener('wpcf7mailsent', e => logEvent({
    'eventCategory': 'Contact Form',
    'eventAction': 'Submission',
    'eventLabel': document.querySelector( 'h1' ).textContent
}));

document.addEventListener( 'click', () => {
    Emitter.emit('click-outside', false );
});
